var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('GIS2DViewer',{attrs:{"appId":"zOPriMbJiAXAsXRj","webMapId":"def9f126c4c34acdb34f3a410bd94bcc"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }